import React from "react";
import { connect } from "react-redux";
import {
  Dialog,
  Pane,
  Button,
  toaster,
  Strong,
  Text,
  InlineAlert,
  SelectField,
} from "evergreen-ui";
import {
  rescheduleBooking,
  reschedulePrice,
  rescheduleBookingVerify,
  getBooking,
} from "../external/actions";
import {
  getFormattedTime,
  getFormattedTime24,
  getFormattedDate,
  getCurrentDate,
  getDateObject,
  getCurrentTime,
  getTimeObject,
} from "../util";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import TimePicker from "../components/timePicker";

class Reschedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDate: getCurrentDate(),
      currentTime: getCurrentTime(),
      selectedDate: getCurrentDate(),
      selectedTime: getCurrentTime(),
      rescheduleSlot: [],
      availableCourtList: [],
      showAvailableSlot: false,
      cort: "",
      showSlotsAvailableAlert: false,
      showSlotsUnavailableAlert: false,
      showSelectACourtAlert: false,
      message: "",
      slots: [],
    };
    this.baseState = this.state;
  }

  dateChange = (date) => {
    this.setState({
      selectedDate: date,
    });
  };

  timeChange = (time) => {
     
    let { currentTime } = this.state;
    if (time !== null) {
      time = getTimeObject(time, "h:mm A");
    
      time = getFormattedTime24(time);
      this.setState({
        selectedTime: time,
      });
    } else {
      this.setState({
        selectedTime: currentTime,
      });
    }
  };

  checkAvailability = async () => {
    let { selectedDate, selectedTime } = this.state;
    selectedDate = getFormattedDate(selectedDate);
    selectedTime = getFormattedTime24(selectedTime);
    const { bookingDetails } = this.props;
    let reqBody = {
      bookingId: bookingDetails.bookingId,
      rescheduleDate: selectedDate,
      startTime: selectedTime,
    };
    await this.props.dispatch(rescheduleBookingVerify(reqBody));
    if (this.props.rescheduleVerifyData && this.props.rescheduleVerifyData.requestStatus === 1) {
      const { rescheduleVerifyData } = this.props;
      this.setState({
        rescheduleSlot: rescheduleVerifyData["rescheduleAvailability"],
        showAvailableSlot: true,
        showSelectACourtAlert: true,
      });
      await this.generateAvailableCourtList();
    } else if (
      this.props.rescheduleVerifyData &&
      this.props.rescheduleVerifyData.requestStatus === -1
    ) {
      toaster.warning("you dont have permission");
    } else {
      toaster.danger(this.props.rescheduleVerifyData && this.props.rescheduleVerifyData.message);
    }
  };

  handleCourtChange = async (e) => {
    let { selectedDate, rescheduleSlot } = this.state;
    const { bookingDetails } = this.props;
    let value, slots;
    if (e.target.value !== "select-court") {
      value = parseInt(e.target.value);
      slots = rescheduleSlot[value].slots;
      selectedDate = getFormattedDate(selectedDate);
      let reqBody = {
        bookingId: bookingDetails.bookingId,
        rescheduleDate: selectedDate,
        slots: slots,
      };
      await this.props.dispatch(reschedulePrice(reqBody));
      if (this.props.reschedulePriceData["requestStatus"] === 1) {
        let { reschedulePriceData } = this.props;
        this.setState({
          message: reschedulePriceData.message,
          reschedulePrice: reschedulePriceData.reschedulePrice,
          slots: reschedulePriceData.slots,
          showSelectACourtAlert: false,
          showSlotsAvailableAlert: true,
          showSlotsUnavailableAlert: false,
        });
      } else if (this.props.reschedulePriceData["requestStatus"] === 0) {
        this.setState({
          message: this.props.reschedulePriceData.message,
          showSelectACourtAlert: false,
          showSlotsAvailableAlert: false,
          showSlotsUnavailableAlert: true,
        });
      } else if (this.props.reschedulePriceData["requestStatus"] === -1) {
        toaster.danger("you dont have permission");
      }
    } else {
      this.setState({
        showSelectACourtAlert: true,
        showSlotsAvailableAlert: false,
        showSlotsUnavailableAlert: false,
      });
    }
  };

  rescheduleConfirm = async () => {
    let { bookingDetails } = this.props;
    let { slots, reschedulePrice } = this.state;
    await this.props.dispatch(
      rescheduleBooking({
        bookingId: bookingDetails.bookingId,
        reschedulePrice,
        slots,
      })
    );
    if (this.props.rescheduleBookingData["requestStatus"] === 1) {
      toaster.success("Booking Rescheduled");
      await this.onCloseDialog(bookingDetails.bookingId);
    } else {
      toaster.danger(this.props.rescheduleBookingData.message);
    }
  };

  generateAvailableCourtList = async () => {
    let { rescheduleSlot } = this.state;
    const courtList = Object.keys(rescheduleSlot).map((key) => {
      return {
        courtName: rescheduleSlot[key].courtName,
        value: key,
        slot: rescheduleSlot[key].slots,
      };
    });
    await this.setState({
      availableCourtList: courtList,
    });
  };

  onCloseDialog = async (bookingId) => {
    const { showRescheduleDialog } = this.props;
    if (bookingId) {
      let reqParams = {
        bookingId: bookingId,
      };
      await this.props.dispatch(getBooking(reqParams));
    }
    this.setState({
      ...this.baseState,
    });
    showRescheduleDialog(false, bookingId);
  };

  render() {
    const {
      currentDate,
      currentTime,
      selectedTime,
      selectedDate,
      availableCourtList,
      showAvailableSlot,
      message,
      showSelectACourtAlert,
      showSlotsAvailableAlert,
      showSlotsUnavailableAlert,
    } = this.state;

    const { isShown, bookingDetails } = this.props;

    const { startTime, endTime, dateBooked, courts } = bookingDetails;

    return (
      <Dialog
        isShown={isShown}
        title='Reschedule'
        onCloseComplete={() => this.onCloseDialog(false)}
        hasFooter={false}
      >
        <Pane display={"flex"} flexDirection={"column"} marginBottom={15}>
          <Strong marginBottom={10}>Booking Details</Strong>
          <Text>
            {`${courts} | ${getFormattedDate(dateBooked, "YYYY-MM-DD", "ddd, Do MMM YY")} |
                        ${getFormattedTime(startTime)} - ${getFormattedTime(endTime)}`}
          </Text>
        </Pane>
        <Pane display={"flex"} flexDirection={"column"} marginTop={15} marginBottom={15}>
          <Strong marginBottom={10}>Reschedule Details</Strong>
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Pane width={"50%"} marginRight={5} display={"flex"} flexDirection={"column"}>
              <Strong>Date</Strong>
              <DatePicker
                className={"date-picker"}
                disabled={!!showAvailableSlot}
                defaultValue={getDateObject(currentDate, "ddd, Do MMM YY")}
                value={getDateObject(selectedDate, "ddd, Do MMM YY")}
                format={"ddd, Do MMM YY"}
                onChange={(e) => {
                  document.querySelector(".date-picker input").blur();
                  this.dateChange(e.format("ddd, Do MMM YY"));
                }}
                style={{
                  width: "100%",
                }}
              />
            </Pane>
            <Pane width={"50%"} marginLeft={5} display={"flex"} flexDirection={"column"}>
              <Strong>Time</Strong>
              <TimePicker
                disabled={!!showAvailableSlot}
                value={getTimeObject(selectedTime, "h:mm A")}
                timeChange={this.timeChange}
              />
            </Pane>
          </Pane>
        </Pane>
        <Pane display={"flex"} flexDirection={"column"}>
          {showAvailableSlot ? (
            <Pane display={"flex"} justifyContent={"space-between"} alignItems={"flex-end"}>
              <Pane width={"70%"} display={"flex"} flexDirection={"column"} marginRight={5}>
                <SelectField
                  label={"Court"}
                  onChange={(event) => this.handleCourtChange(event)}
                  margin={0}
                >
                  <option value='select-court'>Select Court</option>
                  {availableCourtList.map((court) => (
                    <option key={court.value} value={court.value}>
                      {court.courtName}
                    </option>
                  ))}
                </SelectField>
              </Pane>
              <Button
                width={"30%"}
                display={"flex"}
                justifyContent={"center"}
                marginLeft={5}
                appearance={"minimal"}
                onClick={() =>
                  this.setState({
                    ...this.baseState,
                  })
                }
              >
                Reset
              </Button>
            </Pane>
          ) : null}
          {!showAvailableSlot ? (
            <Button
              display={"flex"}
              justifyContent={"center"}
              appearance={"primary"}
              onClick={this.checkAvailability}
            >
              Check Availability
            </Button>
          ) : null}
          {showSelectACourtAlert && (
            <InlineAlert display={"flex"} alignItems={"center"} intent='none' marginTop={5}>
              Select a court
            </InlineAlert>
          )}
          {showSlotsAvailableAlert && (
            <InlineAlert display={"flex"} alignItems={"center"} intent='success' marginTop={20}>
              {message}
            </InlineAlert>
          )}
          {showSlotsUnavailableAlert && (
            <InlineAlert display={"flex"} alignItems={"center"} intent='danger' marginTop={20}>
              {message}
            </InlineAlert>
          )}
        </Pane>
        {showSlotsAvailableAlert ? (
          <Button
            display={"flex"}
            justifyContent={"center"}
            appearance={"primary"}
            marginTop={20}
            width={"100%"}
            onClick={this.rescheduleConfirm}
          >
            Confirm
          </Button>
        ) : null}
      </Dialog>
    );
  }
}

const mapStateToProps = ({
  rescheduleVerifyData,
  reschedulePriceData,
  rescheduleBookingData,
  bookingSearchData,
}) => ({
  rescheduleVerifyData,
  reschedulePriceData,
  rescheduleBookingData,
  bookingSearchData,
});

export default connect(mapStateToProps)(Reschedule);
